function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  "data-name": "Path 87",
  d: "M0,0H16V16H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_332",
  "data-name": "Group 332",
  transform: "translate(-1445.94 -640.93)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_327",
  "data-name": "Group 327"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_326",
  "data-name": "Group 326"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_164",
  "data-name": "Path 164",
  d: "M1459.369,647.038v5.035a.253.253,0,0,1-.133.223l-4.41,2.408a.255.255,0,0,1-.377-.223v-5.035a.253.253,0,0,1,.133-.223l4.41-2.409A.255.255,0,0,1,1459.369,647.038Z",
  fill: "#4d4d4d"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_329",
  "data-name": "Group 329"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_328",
  "data-name": "Group 328"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_165",
  "data-name": "Path 165",
  d: "M1453.43,649.446v5.034a.254.254,0,0,1-.376.224l-4.41-2.408a.253.253,0,0,1-.133-.223v-5.035a.255.255,0,0,1,.377-.223l4.41,2.408A.252.252,0,0,1,1453.43,649.446Z",
  fill: "#4d4d4d"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_331",
  "data-name": "Group 331"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_330",
  "data-name": "Group 330"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_166",
  "data-name": "Path 166",
  d: "M1458.343,645.94l-4.281,2.337a.257.257,0,0,1-.244,0l-4.281-2.337a.255.255,0,0,1,0-.447l4.281-2.338a.257.257,0,0,1,.244,0l4.281,2.338A.255.255,0,0,1,1458.343,645.94Z",
  fill: "#4d4d4d"
}))));

function SvgStsBoxIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "more_vert-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStsBoxIcon);
export default __webpack_public_path__ + "static/media/stsBoxIcon.4fd9d679.svg";
export { ForwardRef as ReactComponent };